import SquareLoader from 'react-spinners/SquareLoader';

export default function Loader() {
  return <SquareLoader />;
}
